import React, { useEffect, useState } from "react";
import { object, func, bool, string } from "prop-types";
import { connect } from "react-redux";

import { verifyEmail, logout } from "../helper/api";
import MemberNotVerifiedView from "../molecules/MemberNotVerifiedView";
import { setMetypeBar, setMember, setJwtToken, setBookmark } from "../helper/actions";
import { MetypeCommentsWidget } from "../atoms/metype-comment";
import { get } from "lodash";

import "./metypeComments.m.css";

const { BroadcastChannel } = require("broadcast-channel");

const MetypeCommentWrapper = ({
  metypeConfig,
  metype,
  onToggleMetype,
  jwtToken,
  authHost,
  member,
  navigateToPage,
  setMetypeBar,
  setMember,
  setJwtToken,
  setBookmark,
  storyFromReducer,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [message, setMessage] = useState(null);
  const channel = new BroadcastChannel("logout-channel");

  channel.onmessage = (msg) => {
    setMessage(msg);
    setMember(null);
    setJwtToken(null);
    setBookmark(null);
  };

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(true);

    const storyUrlObj = storyFromReducer && new URL(storyFromReducer.url);
    const loginUrl = () => {
      const url = new URL(`${authHost}/authenticate`);
      url.searchParams.set("redirect-url", storyFromReducer.url);
      url.searchParams.set("callback-url", storyUrlObj.origin);
      url.searchParams.set("auth-page", `${authHost}/sign-in-page`);
      return url;
    };

    function listenToLogin(event) {
      if (event.data.action === "metype_login") {
        if (member && !member["verification-status"]) {
          verifyEmail(member.email);
          window.location.href = `/verify-email?id=${member.id}`;
        }
        window.location.href = loginUrl();
      }
    }

    window.addEventListener("message", listenToLogin, false);
  }, [storyFromReducer.id]);

  const logoutClick = () => {
    logout().then(() => {
      window.location.reload();
    });
  };

  const setVerification = () => isMobile && setMetypeBar(false);
  return (
    <div
      styleName={`metype-comments-container ${metype ? "translate-metype" : ""}`}
      className="metype-comments-container"
    >
      <div className="comment-wrapper">
        {member && !member["verification-status"] && (
          <div styleName="button-wrapper">
            <MemberNotVerifiedView
              member={member}
              logout={logoutClick}
              navigateToPage={navigateToPage}
              closeView={setVerification}
              src="metype-comments"
              storyUrl={storyFromReducer.url}
            />
          </div>
        )}
        <MetypeCommentsWidget
          host={metypeConfig.metypeHost}
          accountId={metypeConfig.metypeAccountId}
          pageURL={storyFromReducer.url}
          primaryColor={metypeConfig.primaryColor}
          className={metypeConfig.className}
          jwt={jwtToken}
          fontUrl={metypeConfig.fontFamilyUrl}
          fontFamily={metypeConfig.fontFamily}
          message={message}
          storyId={storyFromReducer.id}
        />
      </div>
    </div>
  );
};

MetypeCommentWrapper.propTypes = {
  publisherAttributes: object,
  metypeConfig: object,
  storyUrl: string,
  onToggleMetype: func,
  metype: bool,
  jwtToken: string,
  authHost: string,
  member: object,
  navigateToPage: func,
  setMetypeBar: func,
  setMember: func,
  setJwtToken: func,
  setBookmark: func,
  storyFromReducer: object,
};

const mapStateToProps = (state) => ({
  storyFromReducer: get(state, ["headerReducer", "showStoryHeader"], ""),
});

const mapDispatchToProps = (dispatch) => ({
  navigateToPage: (url) => global.app.navigateToPage(dispatch, url),
  setMetypeBar: (flag) => dispatch(setMetypeBar(flag)),
  setMember: (obj) => dispatch(setMember(obj)),
  setJwtToken: (flag) => dispatch(setJwtToken(flag)),
  setBookmark: (obj) => dispatch(setBookmark(obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MetypeCommentWrapper);
